import { useAutoneTranslation } from '@autone/translations';
import { ASSORTMENT_PATH_APP } from '@autone/ui';

import { type APP_NAME } from '../../consts';

export const AssortmentDocsLink = () => {
  const { common } = useAutoneTranslation<typeof APP_NAME>();
  return (
    <a
      className="hover:cursor-pointer underline text-inherit"
      href={`/${ASSORTMENT_PATH_APP.inSeason}`}
    >
      {common('documentation')}
    </a>
  );
};
